import React from 'react';
import { Box, Typography, Link } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import madeByLogo from '../img/madeby_logo.svg';

const Footer = () => {
  const theme = useTheme();

  return (
    <Box
      component="footer"
      sx={{
        mt: 'auto', // pushes footer to bottom
        py: 2,
        px: 2,
        backgroundColor: theme.palette.background.default,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderTop: `1px solid ${theme.palette.divider}`,
      }}
    >
      <Typography
        variant="body2"
        sx={{
          mr: 1,
          color: theme.palette.text.secondary,
          fontFamily: theme.typography.fontFamily,
        }}
      >
        Made in collaboration with
      </Typography>
      <Link
        href="https://madeby.zaka.ai"
        target="_blank"
        rel="noopener noreferrer"
        underline="none"
      >
        <img
          src={madeByLogo}
          alt="MadeBy"
          style={{ height: 24 }}
        />
      </Link>
    </Box>
  );
};

export default Footer;
